// extracted by mini-css-extract-plugin
export default {"expired-page-container":"expired-page_expired-page-container__Ki30u","expiredPageContainer":"expired-page_expired-page-container__Ki30u"};